
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35223',
  depVersions: {
  "documents-public-ui": "static-1.35223",
  "atom": "static-1.5391",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2786",
  "client-types": "static-1.496",
  "cssUtils": "static-1.926",
  "customer-data-filters-ui": "static-1.40929",
  "customer-data-objects": "static-1.7997",
  "customer-data-property-utils": "static-1.8406",
  "documents-lib": "static-1.35228",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.368",
  "FormsCommonComponents": "static-1.86559",
  "FormUrlGenerator": "static-2.5032",
  "foundations-theming-specialty": "static-1.2498",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5900",
  "hs-test-utils": "static-1.8337",
  "hub-http": "static-1.6518",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12101",
  "HubStyleTokens": "static-2.11794",
  "I18n": "static-7.1674",
  "icons": "static-2.683",
  "jasmine-immutable": "static-1.3327",
  "jasmine-runner": "static-1.6756",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7457",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3198",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5700",
  "quartz": "static-1.7461",
  "react": "static-7.192",
  "react-dlb": "static-1.88",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.6",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5558",
  "react-virtualized": "static-2.107",
  "reference-resolvers": "static-1.8486",
  "reference-resolvers-lite": "static-1.8408",
  "reporting-data": "static-1.68827",
  "reporting-reports": "static-1.68504",
  "reporting-snowflake": "static-1.57444",
  "reporting-testing-lib": "static-1.10760",
  "reporting-visualizations": "static-1.60902",
  "reselect": "static-3.12",
  "sales-content-partitioning": "static-1.9257",
  "sanitize": "static-1.4777",
  "sanitize-text": "static-1.8460",
  "SharedI18nStrings": "static-1.183",
  "SharedLegalStrings": "static-1.2051",
  "signup-constants": "static-1.19632",
  "signup-ui-url-generator": "static-2.8366",
  "StyleGuideUI": "static-3.502",
  "superstore": "static-1.5063",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5065",
  "ui-addon-form-validation": "static-1.11287",
  "ui-asset-management-lib": "static-1.11403",
  "ui-images": "static-2.1249",
  "UIComponents": "static-3.8740",
  "usage-tracker": "static-1.7637",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "viral-links-lib": "static-1.7381",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9960",
  "foundations-components": "static-1.8499",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1239",
  "quartz-core": "static-1.6680",
  "quick-fetch": "static-1.4132",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.80",
  "rpc-client-utils": "static-1.4971",
  "ui-addon-i18n": "static-1.11452",
  "ui-addon-upgrades": "static-9.18391",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3622",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3738",
  "quartz-webpack": "static-1.3685",
  "foundations-assets": "static-1.5190",
  "foundations-theming": "static-1.4782",
  "hub-http-janus": "static-1.880",
  "hub-http-shared-msw-handlers": "static-1.10622",
  "hubspotter-http": "static-1.4866",
  "sassPrefix": "static-1.197",
  "conversations-skeleton-state": "static-1.7551",
  "crm-message-bus": "static-1.43764",
  "customer-data-filters-ui-msw-helpers": "static-1.23364",
  "customer-data-objects-ui-components": "static-1.13335",
  "customer-data-reference-ui-components": "static-1.13482",
  "customer-data-ui-utilities": "static-1.10134",
  "events-data-lib": "static-1.550",
  "framework-builder-read-service-client": "static-1.4222",
  "hs-resources": "static-1.496",
  "immer": "static-1.101",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4056",
  "multi-account-reference-resolvers": "static-1.1310",
  "onboarding-scopes": "static-1.6758",
  "onboarding-tours": "static-1.17123",
  "pulse": "static-1.935",
  "reporting-datasets-permissions-lib": "static-1.14467",
  "stylex": "static-1.41",
  "trellis-assets": "static-1.2651",
  "trellis-components": "static-1.2670",
  "trellis-theming": "static-1.1279",
  "ui-addon-teams": "static-1.21911",
  "quartz-auth": "static-1.1136",
  "ui-business-units-lib": "static-1.9393",
  "usage-tracker-session-replay": "static-1.5323",
  "ai-components-ui-library": "static-1.9719",
  "ContentUtils": "static-1.69128",
  "customer-data-properties": "static-1.52604",
  "forms-ai-lib": "static-1.4766",
  "forms-utils-lib": "static-1.13096",
  "foundations-components-test-utils": "static-1.5982",
  "react-dnd-compat": "static-1.4922",
  "react-tinymce": "static-1.55982",
  "tinymce-config": "static-2.55108",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3767",
  "HeadJS": "static-2.797",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3448",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.296",
  "ui-fonts": "static-1.1056",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4618",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1126",
  "web-vitals": "static-1.15",
  "batch-promise": "static-1.1849",
  "external-options-client-types": "static-1.4340",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7197",
  "quartz-i18n": "static-1.1136",
  "frontend-preferences-client": "static-1.8228",
  "graphql": "static-1.89",
  "persist-promise": "static-1.4006",
  "reporting-client-types": "static-1.2688",
  "apollo-stack-hubspot": "static-3.94",
  "growth-payments-core": "static-1.26181",
  "hubspot-apollo-client": "static-1.5182",
  "foundations-components-legacy": "static-1.1524",
  "quartz-routing": "static-1.891",
  "hs-story-utils": "static-1.9729",
  "react-flip-move": "static-1.78",
  "nested-table": "static-1.539",
  "seat-types-lib": "static-1.729",
  "timezone-utils": "static-2.5549",
  "react-create-root-preference": "static-1.71",
  "bend-plugin-foundations-components": "static-1.4768",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "opentelemetry-fe-types": "static-1.77",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.577",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.452",
  "quartz-test": "static-1.1136",
  "quartz-tracking": "static-1.840",
  "bend-plugin-chirp-manifest": "static-1.381",
  "chirp-fetch": "static-1.2199",
  "merchandise-lib": "static-1.278",
  "purchase-motions-components": "static-1.6368",
  "salesImages": "static-1.567",
  "ts-schema": "static-1.4296",
  "bender-build-tools": "static-1.3444",
  "bend-plugin-foundations-theming": "static-1.3265",
  "restore-request-side-panel-lib": "static-1.1679",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4961",
  "conditional-properties-service-client": "static-1.4016",
  "crm-pipelines-api-client-types": "static-1.4349",
  "event-emitter": "static-1.1258",
  "fdsr-migration-layer": "static-1.316",
  "multi-currency-client-types": "static-1.3912",
  "getting-started-shared-tasks": "static-1.19240",
  "growth-data-modal": "static-1.5900",
  "growth-onboarding-confetti": "static-1.3366",
  "growth-onboarding-next-action-utils": "static-1.2687",
  "navigation-components": "static-1.18836",
  "onboarding-tours-client": "static-1.5338",
  "onboarding-tours-utils": "static-1.1190",
  "ui-shepherd-react": "static-3.10575",
  "ui-shepherd-tracker": "static-1.7956",
  "ui-universal-auth": "static-1.9413",
  "user-context": "static-1.5425",
  "bend-plugin-pulse": "static-1.438",
  "fast-json-patch": "static-1.70",
  "stylex-utils": "static-1.141",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "hubspotter-http-shared-msw-handlers": "static-1.10620",
  "magpie-lib": "static-1.5757",
  "navigation-messaging": "static-1.8163",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23036",
  "copilot-toolkit": "static-1.11851",
  "cms-field-types": "static-1.5119",
  "content-icons-ui": "static-1.2368",
  "integrations-lib": "static-1.17037",
  "calling-global-api": "static-1.65627",
  "calling-internal-common": "static-1.31626",
  "calling-lifecycle-internal": "static-1.67009",
  "calling-lifecycle-messages": "static-1.59303",
  "commerce-products-lib": "static-1.10530",
  "crm-index-visualization-core": "static-1.4546",
  "crm-links": "static-1.6635",
  "customer-data-properties-shared-msw-handlers": "static-1.9949",
  "file-manager-components": "static-1.24502",
  "formula-editor": "static-1.14771",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4429",
  "meetings-icalendar-utils-lib": "static-1.941",
  "object-builder-ui-client": "static-1.49677",
  "pipeline-validation-client-types": "static-1.4184",
  "property-value-citations": "static-1.3218",
  "smart-data-capture-core": "static-1.144",
  "smart-property-lib": "static-1.8298",
  "tiered-pricing": "static-1.1958",
  "topics-actions-lib": "static-1.471",
  "trial-components-library": "static-1.14110",
  "ui-addon-iframeable": "static-1.9381",
  "zustand": "static-1.85",
  "final-form": "static-1.78",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.78",
  "rich-text-lib": "static-1.20308",
  "tinymce-themes": "static-1.57078",
  "data-token-picker": "static-1.16892",
  "hub-http-contrib": "static-1.3344",
  "interframe": "static-3.5060",
  "tinymce-data": "static-1.41193",
  "tinymce-plugins": "static-1.58222",
  "ui-addon-sales-email": "static-1.5517",
  "framework-data-schema-quick-fetch": "static-1.7102",
  "ui-addon-opt": "static-4.8669",
  "hubspot-apollo-cache": "static-1.641",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.455",
  "opentelemetry-web": "static-1.13",
  "purchase-motions-api": "static-1.6371",
  "onboarding-data-sync-lib": "static-1.2516",
  "growth-onboarding-next-action-components": "static-1.2715",
  "user-context-client": "static-1.4811",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5217",
  "nest": "static-1.542",
  "reactive-lib": "static-1.1023",
  "simple-logging-lib": "static-1.3356",
  "unified-auth-core-lib": "static-1.1209",
  "getting-started-shared-tasks-store": "static-1.18358",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1740",
  "integrations-error-boundary-lib": "static-1.14452",
  "integrations-tracking-lib": "static-1.5912",
  "native-integrations-shared-strings": "static-1.8082",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10675",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.927",
  "calling-error-reporting": "static-1.31633",
  "shared-worker-versioning": "static-1.11347",
  "calling-usage-tracker": "static-1.6841",
  "voice-sms-access-library": "static-1.2059",
  "customer-data-tracking": "static-1.7187",
  "commerce-permissions": "static-1.1082",
  "products-iframe-lib": "static-1.8594",
  "products-ui-components-shared-msw-handlers": "static-1.11004",
  "crm-index-associations-lib": "static-1.6746",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10705",
  "sales-views-client-types": "static-1.4561",
  "location-customization-utils-lib": "static-1.10097",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4453",
  "video-components-external": "static-1.12148",
  "video-data-lib": "static-1.35806",
  "bark-lib": "static-1.16817",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6193",
  "react-codemirror": "static-1.10945",
  "data-agent-kit": "static-1.652",
  "feedback-loader": "static-1.29814",
  "fsm": "static-1.4055",
  "policy-lib": "static-1.7106",
  "react-colorpicker": "static-2.10522",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10768",
  "embedded-academy-lib": "static-1.15521",
  "hubs-service-types": "static-1.1564",
  "FileManagerLib": "static-1.40142",
  "NamespacedHubStyle": "static-2.9266",
  "FileManagerCore": "static-1.40001",
  "content-assistance-lib": "static-1.8203",
  "layout-dnd-components": "static-1.12972",
  "layout-dnd-utils": "static-1.11947",
  "ui-addon-emoji-picker": "static-1.10191",
  "ui-brand-identity-lib": "static-1.16477",
  "InboxConnectUtils": "static-4.15560",
  "meetings-connect-utils-lib": "static-1.7914",
  "breeze-engine-chat-components": "static-1.718",
  "breeze-engine-core": "static-1.1018",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "universal-page-editor-lib": "static-1.3313",
  "adobe-sign-auth-lib": "static-1.461",
  "ads-unified-auth-lib": "static-1.1382",
  "generic-oauth-auth-lib": "static-1.55",
  "google-sheets-integration-lib": "static-1.1030",
  "microsoft-drive-auth-lib": "static-1.144",
  "surveymonkey-integration-lib": "static-1.487",
  "slack-ui-library": "static-1.10704",
  "calling-orchestration-schema": "static-1.36836",
  "crm-record-cards-service-types": "static-1.3789",
  "content-media-composition-data-lib": "static-1.13240",
  "content-media-compositions": "static-2.17247",
  "media-bridge-lib": "static-1.19409",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16366",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4813",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.14981",
  "audio-components": "static-1.6347",
  "FileManagerImages": "static-1.37653",
  "video-components": "static-1.14150",
  "breeze-artifacts-sdk": "static-1.345",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4838",
  "video-embed": "static-1.36640",
  "ui-addon-video-player": "static-1.9008",
  "ui-coaching-tips": "static-1.29307",
  "ContentData": "static-1.69203",
  "layout-data-lib": "static-1.10272",
  "academy-service-client": "static-1.3992",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4709",
  "trellis-ecosystem": "static-1.7631",
  "ui-addon-react-router-dom": "static-1.9840",
  "wootric-nps": "static-1.7202",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4459",
  "growth-onboarding-feedback-components": "static-1.6889",
  "advanced-menus-core": "static-1.15579",
  "advanced-menus-lib": "static-1.12453",
  "ExportDialog": "static-6.10682",
  "ui-memberships-settings-lib": "static-1.34844",
  "marketplace-ui-apps-core": "static-1.19263",
  "marketplace-ui-common": "static-1.20731",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15578",
  "simple-menus-lib": "static-1.17095",
  "developer-experience-shared-components": "static-1.10845",
  "immutable-less": "static-1.4955",
  "marketplace-ui-client-types": "static-1.18138",
  "ui-addon-integrations-directory-panel": "static-2.8331",
  "ui-extensibility-client-types": "static-1.4223",
  "ai-settings-ui-library": "static-1.8354",
  "nav-meta": "static-1.30473",
  "ui-product-approvals-common": "static-1.1065",
  "apps-service-types": "static-1.4044",
  "oauth-service-types": "static-1.4543",
  "simple-data-table": "static-1.3530"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35223",
  "atom": "/atom/static-1.5391",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2786",
  "client-types": "/client-types/static-1.496",
  "cssUtils": "/cssUtils/static-1.926",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40929",
  "customer-data-objects": "/customer-data-objects/static-1.7997",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8406",
  "documents-lib": "/documents-lib/static-1.35228",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.368",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86559",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5032",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2498",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5900",
  "hs-test-utils": "/hs-test-utils/static-1.8337",
  "hub-http": "/hub-http/static-1.6518",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12101",
  "HubStyleTokens": "/HubStyleTokens/static-2.11794",
  "I18n": "/I18n/static-7.1674",
  "icons": "/icons/static-2.683",
  "jasmine-immutable": "/jasmine-immutable/static-1.3327",
  "jasmine-runner": "/jasmine-runner/static-1.6756",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7457",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3198",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5700",
  "quartz": "/quartz/static-1.7461",
  "react": "/react/static-7.192",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.6",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5558",
  "react-virtualized": "/react-virtualized/static-2.107",
  "reference-resolvers": "/reference-resolvers/static-1.8486",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8408",
  "reporting-data": "/reporting-data/static-1.68827",
  "reporting-reports": "/reporting-reports/static-1.68504",
  "reporting-snowflake": "/reporting-snowflake/static-1.57444",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10760",
  "reporting-visualizations": "/reporting-visualizations/static-1.60902",
  "reselect": "/reselect/static-3.12",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9257",
  "sanitize": "/sanitize/static-1.4777",
  "sanitize-text": "/sanitize-text/static-1.8460",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2051",
  "signup-constants": "/signup-constants/static-1.19632",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8366",
  "StyleGuideUI": "/StyleGuideUI/static-3.502",
  "superstore": "/superstore/static-1.5063",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5065",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11287",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11403",
  "ui-images": "/ui-images/static-2.1249",
  "UIComponents": "/UIComponents/static-3.8740",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "viral-links-lib": "/viral-links-lib/static-1.7381",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9960",
  "foundations-components": "/foundations-components/static-1.8499",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1239",
  "quartz-core": "/quartz-core/static-1.6680",
  "quick-fetch": "/quick-fetch/static-1.4132",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.80",
  "rpc-client-utils": "/rpc-client-utils/static-1.4971",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11452",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18391",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3622",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3738",
  "quartz-webpack": "/quartz-webpack/static-1.3685",
  "foundations-assets": "/foundations-assets/static-1.5190",
  "foundations-theming": "/foundations-theming/static-1.4782",
  "hub-http-janus": "/hub-http-janus/static-1.880",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10622",
  "hubspotter-http": "/hubspotter-http/static-1.4866",
  "sassPrefix": "/sassPrefix/static-1.197",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7551",
  "crm-message-bus": "/crm-message-bus/static-1.43764",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23364",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13335",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13482",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10134",
  "events-data-lib": "/events-data-lib/static-1.550",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4222",
  "hs-resources": "/hs-resources/static-1.496",
  "immer": "/immer/static-1.101",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4056",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1310",
  "onboarding-scopes": "/onboarding-scopes/static-1.6758",
  "onboarding-tours": "/onboarding-tours/static-1.17123",
  "pulse": "/pulse/static-1.935",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14467",
  "stylex": "/stylex/static-1.41",
  "trellis-assets": "/trellis-assets/static-1.2651",
  "trellis-components": "/trellis-components/static-1.2670",
  "trellis-theming": "/trellis-theming/static-1.1279",
  "ui-addon-teams": "/ui-addon-teams/static-1.21911",
  "quartz-auth": "/quartz-auth/static-1.1136",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9393",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9719",
  "ContentUtils": "/ContentUtils/static-1.69128",
  "customer-data-properties": "/customer-data-properties/static-1.52604",
  "forms-ai-lib": "/forms-ai-lib/static-1.4766",
  "forms-utils-lib": "/forms-utils-lib/static-1.13096",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5982",
  "react-dnd-compat": "/react-dnd-compat/static-1.4922",
  "react-tinymce": "/react-tinymce/static-1.55982",
  "tinymce-config": "/tinymce-config/static-2.55108",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3767",
  "HeadJS": "/HeadJS/static-2.797",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3448",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.296",
  "ui-fonts": "/ui-fonts/static-1.1056",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4618",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1126",
  "web-vitals": "/web-vitals/static-1.15",
  "batch-promise": "/batch-promise/static-1.1849",
  "external-options-client-types": "/external-options-client-types/static-1.4340",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7197",
  "quartz-i18n": "/quartz-i18n/static-1.1136",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8228",
  "graphql": "/graphql/static-1.89",
  "persist-promise": "/persist-promise/static-1.4006",
  "reporting-client-types": "/reporting-client-types/static-1.2688",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "growth-payments-core": "/growth-payments-core/static-1.26181",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5182",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1524",
  "quartz-routing": "/quartz-routing/static-1.891",
  "hs-story-utils": "/hs-story-utils/static-1.9729",
  "react-flip-move": "/react-flip-move/static-1.78",
  "nested-table": "/nested-table/static-1.539",
  "seat-types-lib": "/seat-types-lib/static-1.729",
  "timezone-utils": "/timezone-utils/static-2.5549",
  "react-create-root-preference": "/react-create-root-preference/static-1.71",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4768",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.77",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.577",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.452",
  "quartz-test": "/quartz-test/static-1.1136",
  "quartz-tracking": "/quartz-tracking/static-1.840",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.381",
  "chirp-fetch": "/chirp-fetch/static-1.2199",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "purchase-motions-components": "/purchase-motions-components/static-1.6368",
  "salesImages": "/salesImages/static-1.567",
  "ts-schema": "/ts-schema/static-1.4296",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3265",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1679",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4961",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4016",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4349",
  "event-emitter": "/event-emitter/static-1.1258",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.316",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3912",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19240",
  "growth-data-modal": "/growth-data-modal/static-1.5900",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3366",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2687",
  "navigation-components": "/navigation-components/static-1.18836",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5338",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1190",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10575",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7956",
  "ui-universal-auth": "/ui-universal-auth/static-1.9413",
  "user-context": "/user-context/static-1.5425",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.438",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "stylex-utils": "/stylex-utils/static-1.141",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10620",
  "magpie-lib": "/magpie-lib/static-1.5757",
  "navigation-messaging": "/navigation-messaging/static-1.8163",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23036",
  "copilot-toolkit": "/copilot-toolkit/static-1.11851",
  "cms-field-types": "/cms-field-types/static-1.5119",
  "content-icons-ui": "/content-icons-ui/static-1.2368",
  "integrations-lib": "/integrations-lib/static-1.17037",
  "calling-global-api": "/calling-global-api/static-1.65627",
  "calling-internal-common": "/calling-internal-common/static-1.31626",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67009",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59303",
  "commerce-products-lib": "/commerce-products-lib/static-1.10530",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4546",
  "crm-links": "/crm-links/static-1.6635",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9949",
  "file-manager-components": "/file-manager-components/static-1.24502",
  "formula-editor": "/formula-editor/static-1.14771",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4429",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.941",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49677",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4184",
  "property-value-citations": "/property-value-citations/static-1.3218",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.144",
  "smart-property-lib": "/smart-property-lib/static-1.8298",
  "tiered-pricing": "/tiered-pricing/static-1.1958",
  "topics-actions-lib": "/topics-actions-lib/static-1.471",
  "trial-components-library": "/trial-components-library/static-1.14110",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9381",
  "zustand": "/zustand/static-1.85",
  "final-form": "/final-form/static-1.78",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rich-text-lib": "/rich-text-lib/static-1.20308",
  "tinymce-themes": "/tinymce-themes/static-1.57078",
  "data-token-picker": "/data-token-picker/static-1.16892",
  "hub-http-contrib": "/hub-http-contrib/static-1.3344",
  "interframe": "/interframe/static-3.5060",
  "tinymce-data": "/tinymce-data/static-1.41193",
  "tinymce-plugins": "/tinymce-plugins/static-1.58222",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5517",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7102",
  "ui-addon-opt": "/ui-addon-opt/static-4.8669",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.641",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.455",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "purchase-motions-api": "/purchase-motions-api/static-1.6371",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2516",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2715",
  "user-context-client": "/user-context-client/static-1.4811",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5217",
  "nest": "/nest/static-1.542",
  "reactive-lib": "/reactive-lib/static-1.1023",
  "simple-logging-lib": "/simple-logging-lib/static-1.3356",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1209",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18358",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1740",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14452",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5912",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8082",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10675",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.927",
  "calling-error-reporting": "/calling-error-reporting/static-1.31633",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11347",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6841",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2059",
  "customer-data-tracking": "/customer-data-tracking/static-1.7187",
  "commerce-permissions": "/commerce-permissions/static-1.1082",
  "products-iframe-lib": "/products-iframe-lib/static-1.8594",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11004",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6746",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10705",
  "sales-views-client-types": "/sales-views-client-types/static-1.4561",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10097",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4453",
  "video-components-external": "/video-components-external/static-1.12148",
  "video-data-lib": "/video-data-lib/static-1.35806",
  "bark-lib": "/bark-lib/static-1.16817",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6193",
  "react-codemirror": "/react-codemirror/static-1.10945",
  "data-agent-kit": "/data-agent-kit/static-1.652",
  "feedback-loader": "/feedback-loader/static-1.29814",
  "fsm": "/fsm/static-1.4055",
  "policy-lib": "/policy-lib/static-1.7106",
  "react-colorpicker": "/react-colorpicker/static-2.10522",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10768",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15521",
  "hubs-service-types": "/hubs-service-types/static-1.1564",
  "FileManagerLib": "/FileManagerLib/static-1.40142",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9266",
  "FileManagerCore": "/FileManagerCore/static-1.40001",
  "content-assistance-lib": "/content-assistance-lib/static-1.8203",
  "layout-dnd-components": "/layout-dnd-components/static-1.12972",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11947",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10191",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16477",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15560",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7914",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.718",
  "breeze-engine-core": "/breeze-engine-core/static-1.1018",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3313",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.461",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1382",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.55",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1030",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.144",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.487",
  "slack-ui-library": "/slack-ui-library/static-1.10704",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36836",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3789",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13240",
  "content-media-compositions": "/content-media-compositions/static-2.17247",
  "media-bridge-lib": "/media-bridge-lib/static-1.19409",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16366",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4813",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.14981",
  "audio-components": "/audio-components/static-1.6347",
  "FileManagerImages": "/FileManagerImages/static-1.37653",
  "video-components": "/video-components/static-1.14150",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.345",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4838",
  "video-embed": "/video-embed/static-1.36640",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9008",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29307",
  "ContentData": "/ContentData/static-1.69203",
  "layout-data-lib": "/layout-data-lib/static-1.10272",
  "academy-service-client": "/academy-service-client/static-1.3992",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4709",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7631",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9840",
  "wootric-nps": "/wootric-nps/static-1.7202",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4459",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6889",
  "advanced-menus-core": "/advanced-menus-core/static-1.15579",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12453",
  "ExportDialog": "/ExportDialog/static-6.10682",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34844",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19263",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20731",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15578",
  "simple-menus-lib": "/simple-menus-lib/static-1.17095",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10845",
  "immutable-less": "/immutable-less/static-1.4955",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18138",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8331",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4223",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8354",
  "nav-meta": "/nav-meta/static-1.30473",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1065",
  "apps-service-types": "/apps-service-types/static-1.4044",
  "oauth-service-types": "/oauth-service-types/static-1.4543",
  "simple-data-table": "/simple-data-table/static-1.3530"
}
};
